define('Cart.AddToCart.FixAddingTwice', [
    'Cart.AddToCart.Button.View',

    'jQuery',
    'underscore'
],
function CartAddToCartFixAddingTwice(
    CartAddToCartButtonView,

    jQuery,
    _
) {
    'use strict';

    var lastAddition = 0;

    CartAddToCartButtonView.prototype.addToCart = _(CartAddToCartButtonView.prototype.addToCart).wrap(function addToCart(fn) {
        var timestamp = Date.now();
        var difference = timestamp - lastAddition;

        if (difference < 250) {
            // this add to cart is too close to the previous one, we assume this is because a duplicated event.
            // when clicking the <i> inside our button this is happening.
            return false;
        }

        lastAddition = timestamp;

        fn.apply(this, _(arguments).toArray().slice(1));

        return false;
    });
});

